import { useState } from "react";
import { useTranslation } from "react-i18next";
import { InfiniteScroll } from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { Tutorials } from "../../../interface/GeneralResponse";
import ComplaintsAndSuggestions from "./ComplaintsAndSuggestions";

const HelpCenter = () => {
  const { t } = useTranslation();
  const [tutorialData, setTutorialData] = useState<Tutorials[]>();
 
  const getYouTubeEmbedUrl = (url: string) => {
    if (!url) return ""; 
    if (url.includes("youtu.be/")) {
      const match = url.match(/youtu\.be\/([^?]+)/);
      return match ? `https://www.youtube.com/embed/${match[1]}` : url;
    } 
    if (url.includes("youtube.com/watch")) {
      const match = url.match(/[?&]v=([^&]+)/);
      return match ? `https://www.youtube.com/embed/${match[1]}` : url;
    }

    return url;
  };

  const isYouTubeUrl = (url: string) => {
    return url?.includes("youtube.com") || url?.includes("youtu.be");
  };

  return (
    <div className="overflow-y-auto">
      <div className="flex flex-wrap items-center justify-between gap-5 my-2">
        <h1 className="mb-4 text-xl font-bold">{t("tutorials")}</h1>
        <ComplaintsAndSuggestions />
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {tutorialData?.map((e, index: number) => {
          const isYouTube = isYouTubeUrl(e.Url);

          return (
            <div className="flex flex-col gap-2" key={index}>
              {isYouTube ? (
                <div className="relative aspect-video w-full overflow-hidden rounded-lg">
                  <iframe
                    className="absolute inset-0 h-full w-full"
                    src={getYouTubeEmbedUrl(e.Url)}
                    title={e.Title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              ) : (
                <video
                  className="h-40 w-full rounded-lg object-cover"
                  controls
                  preload="metadata"
                >
                  <source src={e.Url} type="video/mp4" />
                </video>
              )}
              <p className="text-sm font-semibold">{e.Description}</p>
              <p className="text-xs text-body-text">{e.Title}</p>
            </div>
          );
        })}
        <InfiniteScroll
          Count={12}
          skeletonCount={12}
          endpoint={EndPoints.Tutorials}
          getData={(data) => setTutorialData(data)}
          renderSkeleton={
            <div className="flex flex-col gap-2">
              <div className="h-40 animate-pulse rounded-lg bg-body-text" />
              <p className="h-4 animate-pulse rounded-md bg-body-text" />
              <p className="h-4 w-4/5 animate-pulse rounded-md bg-body-text" />
              <p className="h-4 w-1/3 animate-pulse rounded-md bg-body-text" />
            </div>
          }
        />
      </div>
    </div>
  );
};

export default HelpCenter;
